import {useSocket} from "../../../helpers/socket";
import Live2TCWrapper from "./Live2TCWrapper";

const MainTCWrapper = ({config}) => {
    const getResultPlf = config.type === "vnone" ? "mc" : config.type;
    const {socket} = useSocket({platform: `${getResultPlf}_website`})
    return <Live2TCWrapper socket={socket} config={config}/>
}

export default MainTCWrapper;